import { Navigate, Outlet } from "react-router-dom";
import MainLayout from "../../components/layout/MainLayout";
import InactivityGuard from "./InactivityGuard";
import { getStoredAuthToken, isPublicLogout } from "../../utils/restoreAuthSession";

function hasStoredSession(): boolean {
  try {
    return Boolean(getStoredAuthToken());
  } catch {
    return false;
  }
}

const PrivateRoute = ({ children }: any) => {
  if (!hasStoredSession()) {
    if (isPublicLogout()) {
      return <Navigate to="/" replace />;
    }
    const redirect = `${window.location.pathname}${window.location.search}`;
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(redirect)}`}
        replace
      />
    );
  }

  if (children) {
    return (
      <MainLayout>
        <InactivityGuard />
        {children}
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <InactivityGuard />
      <Outlet />
    </MainLayout>
  );
};

export default PrivateRoute;
